import { ref } from 'vue'
import { getNextTimeSlot } from '@/utils/commonFunction'
import { getPWADomain } from '@/api/common'
import { Capacitor } from '@capacitor/core'

//Interfaces
export interface SideMenuListItem {
  activity_icon: string
  name: string
}
export interface MoneyItem {
  id: number
  type: string
  style: Record<string, string>
}
export interface PwaPopupSupportParams {
  showRef: Ref<boolean>
  statusRef: any
  toastContentRef: Ref<string>
  isSuccessRef: Ref<boolean>
  contactRef: any
  loadingRef: any
  userStore: any
}

export interface TabItem {
  display: boolean,
  title: string,
  default_url: string,
  redirectUrl: string
  active_url: string
}

// Constant
export const SHARE_LIST = [
  { img: require('@/assets/sideNavbar/home_share_18.png') },
  { img: require('@/assets/sideNavbar/home_share_facebook.png') },
  { img: require('@/assets/sideNavbar/home_share_telegram.png') }
]

// Functions
import { checkDate, convertStringToArray } from "@/utils/commonFunction";
import { playClickSound } from "@/utils/media";
import { Share } from "@capacitor/share";
import { Ref } from "vue";
import { Router, useRouter } from "vue-router";
import { useThemeStore } from '@/stores/theme'
import { useUserStore } from '@/stores/user'

export const getAmountSum = (data: { date: string; amount: number }[]): number => {
  return data.reduce((sum, item) => sum + Number(item.amount || 0), 0)
}

export const getDayList = (type: string, data: any): any => {
  if (type === 'TURNOVER') {
    return convertStringToArray(data)
  } else if (type === 'LOSS' || type === 'RECHARGE') {
    return data
  } else {
    return data
  }
}

export const getBetList = (betList: any[], isShowTodayCard: boolean): any[] => {
  if (isShowTodayCard) {
    return betList.filter(item => checkDate(item.createTime) !== 0)
  } else {
    return betList
  }
}

export const navToBack = (
  router: Router,
  isPopupCloseBackIcon: boolean,
  emits: (event: 'closePopup') => void
) => {
  if (!isPopupCloseBackIcon) {
    router.go(-1)
  } else {
    emits('closePopup')
  }
}

export const copyID = (value: number, statusRef: any): void => {
  console.log('heyy=', value);

  if (value) {
    navigator.clipboard.writeText(value.toString())
    console.log('statusRef,', statusRef.value);

    statusRef?.value?.open()
  }
}

export const handleMenuClick = (
  name: string,
  router: ReturnType<typeof useRouter>,
  agentRef?: any,
  collectPopupRef?: any,
  collectTimeDropPopupRef?: any,
  pwaPopupRef?: any,
  pwaPopupStatusRef?: any,
  show?: any,
  canReceivedRewards?: number,
  isOpen?: number,
  t?: any,
  handleShowTreasurePopup?: any
): void => {
  playClickSound()

  switch (name) {
    case 'user_referral_reward':
      router.push('/sdagency')
      break
    case 'lucky_wheel':
      router.push('/cashwheel')
      break
    case 'recharge_bargain_sales':
      router.push('/sdbigdep')
      break
    case 'agent_cash_back':
      agentRef?.value?.open()
      show && (show.value = false)
      break
    case 'vip_reward':
      router.push('/sd-vip')
      break
    case 'red_envelope_rain':
      collectTimeDropPopupRef?.value?.open()
      break
    case 'game_benefit':
      router.push('/lossRelief')
      break
    case 'mystery':
      router.push('/sdmystery')
      break
    case 'user_rank':
      router.push('/sd-level')
      break
    case 'first_recharge':
      router.push('/firstRecharge')
      break
    case 'recharge_gift':
      router.push('/rechargeGift')
      break
    case 'return_turnover':
      router.push('/returnTrunover')
      break
    case 'daily_first_recharge':
      router.push('/firstDeposit')
      break
    case 'signin_rewards':
      router.push('/checkinRewards')
      break
    case 'pwa_reward':
      if (canReceivedRewards === 1 || isOpen === 0) {
        pwaPopupStatusRef?.value?.open(t?.('rewards.notActivated'))
      } else {
        pwaPopupRef?.value?.open()
      }
      show && (show.value = false)
      break
    case 'active_tresure_chest':
      router.push('/sdactivechest')
      break
    case 'redeem_code':
      router.push('/giftCode')
      break
    case 'active_bonus':
      router.push('/activeBonus')
      break
    case 'login_treasure_chest':
      handleShowTreasurePopup('login_treasure_chest')
      break
      case 'next_day_treasure_chest':
      handleShowTreasurePopup('next_day_treasure_chest')
      break
      case 'return_treasure_chest':
      handleShowTreasurePopup('return_treasure_chest')
      break
      case 'daily_treasure_chest':
      handleShowTreasurePopup('daily_treasure_chest')
      break
       case 'admin_recharge':
      handleShowTreasurePopup('admin_recharge')
      break
    default:
      show && (show.value = false)
      break
  }
}

export const useButtonClick = (walletPopupRef?: Ref<any>, sidebarShowRef?: Ref<boolean>) => {
  const router = useRouter()
  const themestore = useThemeStore()

  const buttonClick = (type: string) => {
    playClickSound()

    if (themestore.themeIndex === 1) {
      if (type === 'topup') {
        router.push('/sd-topup')
      } else if (type === 'withdraw') {
        router.push('/sd-withdraw')
      }
    } else if (themestore.themeIndex === 2) {
      if (type === 'topup') {
        walletPopupRef?.value?.openPopup(0)
        sidebarShowRef && (sidebarShowRef.value = false) 
      } else if (type === 'withdraw') {
        walletPopupRef?.value?.openPopup(1)
        sidebarShowRef && (sidebarShowRef.value = false) 
      }
    }
  }

  return { buttonClick }
}



export const goToShare = async () => {
  const shareLink = 'https://ggapp.hk9999z.com/#?ref=GE4ZHM'
  localStorage.setItem('shareLink', shareLink)

  const link = localStorage.getItem('shareLink')
 
  try {
       if (!link) return

  await Share.share({
    text: link,
  })
    } catch (error) {
       console.warn('Not supporting') 
    }
}

export const useMoneyRain = () => {
  const moneyList = ref<MoneyItem[]>([])
  const moneyTypes = ['money1', 'money2', 'money3', 'money4']
  let idCounter = 0
  let spawnInterval: number

  const spawnMoney = () => {
    const type = moneyTypes[Math.floor(Math.random() * moneyTypes.length)]
    const left = Math.random() * 100
    const duration = 6 + Math.random() * 4
    const rotation = Math.random() > 0.5 ? 720 : -720

    const item: MoneyItem = {
      id: idCounter++,
      type,
      style: {
        left: `${left}vw`,
        animationDuration: `${duration}s`,
        '--rotation': `${rotation}deg`,
      },
    }

    moneyList.value.push(item)

    setTimeout(() => {
      moneyList.value = moneyList.value.filter((i) => i.id !== item.id)
    }, duration * 1000)
  }

  const startMoneyRain = () => {
    spawnInterval = window.setInterval(() => {
      for (let i = 0; i < 15; i++) {
        spawnMoney()
      }
    }, 300)
  }

  const stopMoneyRain = () => {
    clearInterval(spawnInterval)
  }

  return {
    moneyList,
    startMoneyRain,
    stopMoneyRain,
  }
}

export const openPopup = (params: any) => {
  const { show, userStore, isOpen, canReceivedRewards, timeDuration } = params
  const isNativeApp = Capacitor.isNativePlatform()
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone

  if (!isStandalone && !isNativeApp) {
    if (isOpen.value === 1 && canReceivedRewards.value === 0) {
      show.value = true
      userStore.setPwaShowing(true)
      userStore.setPWAPopupShowTimes(getNextTimeSlot(timeDuration.value))
    }
  }
}

export const closePopup = (params: any) => {
  const userStore = useUserStore()
  const { show, contactRef } = params
  show.value = false
  userStore.setPwaShowing(false)
  contactRef.value.close()
}

export const showError = (params: any, message: string) => {
  const { toastContent, isSuccess, statusRef } = params
  toastContent.value = message
  isSuccess.value = false
  statusRef.value.open()
}

export const showSuccess = (params: any, message: string) => {
  const { toastContent, isSuccess, statusRef } = params
  toastContent.value = message
  isSuccess.value = true
  statusRef.value.open()
}

export const openContactPopup = (params: any) => {
  params.contactRef.value.open()
}

export const goToPlayStore = async (params: any) => {
  const { loadingRef, pwaDomainInfo, pwaID } = params
  let url = pwaDomainInfo.value.domainName
  const token = localStorage.getItem('token')
  const clientId = process.env.VUE_APP_CLIENT_ID
  const tenantId = process.env.VUE_APP_BASE_TENANT_ID ?? '000000'

  if (url) {
    if (token) {
      const redirectUrl = `${url}?token=${encodeURIComponent(token)}&clientId=${encodeURIComponent(clientId)}&tenantId=${encodeURIComponent(tenantId)}`  
      window.open(redirectUrl, '_blank')
    } else {
      window.open(url, '_blank')
    }
  } else {
    loadingRef.value.open()
    try {
      const res = await getPWADomain({ id: pwaID.value })
      loadingRef.value.close()
      closePopup(params)
      url = res.data?.domainName
      if (url) {
        window.open(url, '_blank')
      } else {
        showError(params, '')
      }
    } catch (err: any) {
      loadingRef.value.close()
      showError(params, err)
    }
  }
}


export const goToPathFunc = async <T extends (event: any, ...args: any[]) => void>(
  path: string,
  indexValue: number,
  activeFooter: Ref<number>,
  router: Router,
  promotionRef: Ref<any>,
  agentPopupRef: Ref<any>,
  registerRef: Ref<any>,
  emits: T,
  playClickSound: () => void
) => {
  if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
  activeFooter.value = indexValue
  playClickSound()

  if (path == '/home') {
    activeFooter.value = 0
    router.push(path)
    promotionRef.value.close()
    agentPopupRef.value.close()
    emits('profileClose')
  } else if (path == '/sd-topup') {
    activeFooter.value = 1
    router.push(path)
    emits('profileClose')
    promotionRef.value.close()
    agentPopupRef.value.close()

  } else if (path == '/agent') {
    agentPopupRef.value.open()
    promotionRef.value.close()
    emits('profileClose')
    activeFooter.value = 2

  } else if (path == '/promotion') {
    agentPopupRef.value.close()
    activeFooter.value = 3
    promotionRef.value.open()
    emits('profileClose')
  } else if (path == '/profile') {
    activeFooter.value = 4
    if (localStorage.getItem('token')) {
      emits('goToProfile')
      agentPopupRef.value.close()
      activeFooter.value = 4
    } else {
      activeFooter.value = 0
      registerRef.value.open(1);
    }
  }
  localStorage.setItem('footerPopupOpen', String(activeFooter.value))

};

export const goToPathFuncThem2 = async <T extends (event: any, ...args: any[]) => void>(
  path: string,
  indexValue: number,
  activeFooter: Ref<number>,
  router: Router,
  promotionRef: Ref<any>,
  walletPopupRef: Ref<any>,
  agentPopupRef: Ref<any>,
  registerRef: Ref<any>,
  emits: T,
  playClickSound: () => void
) => {
  if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
  activeFooter.value = indexValue
  playClickSound()

  if (path == '/home') {
    activeFooter.value = 0
    router.push(path)
    promotionRef.value.close()
    agentPopupRef.value.close()
    walletPopupRef.value?.closePopup()
    emits('profileClose')
  } else if (path == '/sd-carteira') {
    if (localStorage.getItem('token')) {
      walletPopupRef.value?.openPopup(0)
      emits('profileClose')
      promotionRef.value.close()
      agentPopupRef.value.close()
      activeFooter.value = 2
    } else {
      activeFooter.value = 0
      registerRef.value.open(1);
    }
  } else if (path == '/agent') {
    agentPopupRef.value.open()
    promotionRef.value.close()
    walletPopupRef.value?.closePopup()
    emits('profileClose')
    activeFooter.value = 1

  } else if (path == '/promotion') {
    agentPopupRef.value.close()
    walletPopupRef.value?.closePopup()
    activeFooter.value = 3
    promotionRef.value.open()
    emits('profileClose')
  } else if (path == '/profile') {
    activeFooter.value = 4
    promotionRef.value.close()
    if (localStorage.getItem('token')) {
      emits('goToProfile')
      agentPopupRef.value.close()
      walletPopupRef.value?.closePopup()
      activeFooter.value = 4
    } else {
      activeFooter.value = 0
      registerRef.value.open(1);
    }
  }
  localStorage.setItem('footerPopupOpen', String(activeFooter.value))

};

export const handlePopupCloseFunc = (
  activeFooter: Ref<number>,
  promotionRef: Ref<any>,
) => {
  if (localStorage.getItem('openPromotionPopup') == 'true' && localStorage.getItem('footerPopupOpen') == '2') {
    promotionRef.value.open();
    localStorage.setItem('openPromotionPopup', '');
    localStorage.setItem('footerPopupOpen', String(3))
  } else {
    localStorage.setItem('footerPopupOpen', String(0))
    activeFooter.value = 0
    localStorage.setItem('openPromotionPopup', '');
  }
}
